import { Injectable } from '@angular/core';
import { AALocationModel, RoutePlannerDataModel } from '../../models/route-model';
import { RoutePlannerService } from '../route-planner/route-planner.service';
import { AppError } from 'src/app/core/models/constants';
import { AARoutePlannerEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { RouteValidationMessage } from 'src/app/core/events/events';
import { Enums } from '../../enums/route.enum';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';

@Injectable({
  providedIn: 'root'
})
export class RoutePlannerViaService {
  private readonly MAX_VIA_ROUTE: number = 4;
  public routeDataModel: RoutePlannerDataModel;
  public viaFlag = false;

  constructor(
    private routePlannerService: RoutePlannerService,
    private eventsService: EventsService) {
    this.routeDataModel = this.routePlannerService.routeDataModel;

    this.eventsService.on(AARoutePlannerEvents.REVERSE_ROUTE, this.reverseRoute );
  }

  get viaRouteList(): Array<AALocationModel> {
    return this.routePlannerService.routeDataModel.ViaRoutes;
  }

  get getMaxRoute() {
    return this.MAX_VIA_ROUTE;
  }

  public applyViaRouteFromURL(viaRoute: string): void {
    const viaLocations: Array<string> = viaRoute.split(AARouterURL._SEPARATOR);

    if (viaLocations.length) {
      const viaRoutesBackup: Array<AALocationModel> = [...this.viaRouteList];
      this.routePlannerService.routeDataModel.resetVia();
      viaLocations.forEach( locationName => {
        const existingLocation: AALocationModel = this.getViaLocationByName(viaRoutesBackup, locationName);
        if ( !existingLocation ) {
          this.addViaRouteByName(locationName, false);
        } else {
          this.addViaLocation(existingLocation, false);
        }
      });
    }
  }

  private getViaLocationByName(viaRoutesBackup: Array<AALocationModel>, locationName: string): AALocationModel {
    const locationList = viaRoutesBackup.filter( location => {
      return (location.Name.toLowerCase() === locationName.toLowerCase() && (location.PlaceId || location.valid()) );
    });
    return locationList[0];
   }

  reverseRoute = (args): void => {
    if (this.validateViaRoute() ) {
      this.viaFlag = false;
      this.routePlannerService.routeDataModel.reverseVia();
    } else {
      this.viaFlag = true;
      this.eventsService.dispatch(RouteValidationMessage.VIA_MESSAGE, AppError.VIA_ROUTE_MISSING);
    }
  }

  public addViaRouteByName(locationName: string = '', isNewRoute: boolean = true): AALocationModel {
    const newLocation: AALocationModel = new AALocationModel(locationName, 0, 0, Enums.RouteType.ViaDestination);
    this.addViaLocation(newLocation, isNewRoute);

    return newLocation;
  }

  // check and remove if the last last via route are empty
  public validateLastViaRoute() {
    if (this.viaRouteList.length) {
      const lastViaLocation: AALocationModel = this.viaRouteList[this.viaRouteList.length - 1];
      if (!lastViaLocation.validName()) {
        this.removeViaRoute(lastViaLocation);
      }
    }
  }

  public addViaLocation(locationModel: AALocationModel, isNewRoute: boolean = true): boolean {
    if (this.viaRouteList.length < this.MAX_VIA_ROUTE) {
      this.viaRouteList.push( locationModel );
      locationModel.isNewRoute = isNewRoute;
      return true;
    }
    return false;
  }

  public removeViaRoute(viaRoute: AALocationModel): void {
    if (this.viaRouteList.length > 0) {
      const indx = this.viaRouteList.indexOf(viaRoute);
      this.viaRouteList.splice(indx, 1);

      if (!viaRoute.isNewRoute) {
        this.routePlannerService.updateGoogleMap();
      }
    }
  }

  public validateViaRoute(): boolean {
    for (let validateCounter = 0; validateCounter < this.viaRouteList.length; validateCounter++ ) {
      const viaLocation: AALocationModel = this.viaRouteList[validateCounter];
      viaLocation.validateLocationName();

      if (viaLocation.validName() === false) {
        return false;
      }
    }
    return true;
  }

  public updateViaLocationByIndex(location: AALocationModel, index: number): boolean {
    const viaLocation: AALocationModel = this.viaRouteList[index];

    if (viaLocation && location) {
      viaLocation.Name = location.Name;
      viaLocation.Latitude = location.Latitude;
      viaLocation.Longitude = location.Longitude;
      return true;
    }
    return false;
  }

}
